export default "__VITE_ASSET__pLEg8xfH__"